import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ProductEnrichmentApiService {
  private httpClient = inject(HttpClient);

  getEnrichmentSearchResult(rid, keyword) {
    rid = rid.replace('#', '');
    return this.httpClient.get(`/api/v1/enrich/product/${rid}?keyword=${keyword}`);
  }

  enrichProduct(rid, data) {
    const payload = {
      payload: data
    };
    return this.httpClient.post(`/api/v1/enrich/product/${rid}`, payload);
  }
}
